<template>
  <div class="order">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="orderNum" placeholder="请输入订单编号" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-select class="s_input" v-model="orderStatus" placeholder="请输入订单状态" clearable @change="onSearch">
          <el-option v-for="item in orderStatusOptions" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-date-picker v-model="formInline.time" @change="gettime" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期"
          style="border-radius: 10px;  margin-left: 20px; border: 1px solid #ccc" value-format="yyyy-MM-dd">
        </el-date-picker>

      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="orderNum" label="订单编号"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="orderName" label="订单名称"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="orderStatus" label="订单状态">
            <template slot-scope="scope">
              <span v-if="scope.row.orderStatus == -1">已取消</span>
              <span v-if="scope.row.orderStatus == 0">待支付</span>
              <span v-if="scope.row.orderStatus == 1">已支付</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="orderAmount" label="订单金额(元)"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="createdTime" label="下单时间"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="payTime" label="支付时间">
            <template slot-scope="scope">
              <span>{{ scope.row.payTime || '--' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      orderNum: "",//订单编号
      orderStatus: "",//订单状态
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
      startTime: '',//开始时间
      endTime: '',//结束时间
      formInline: {
        time: []
      },//日期区间,
      orderStatusOptions: [
        { value: "0", label: "待支付" },
        { value: "1", label: "已支付" },
        { value: "-1", label: "已取消" },
      ],
    }
  },
  created() {
    this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.orderList, {
          params: {
            orderStatus: this.orderStatus || null, // 订单状态：-1已取消；0待付款 ；1已支付；2已退款
            orderNum: this.orderNum || null,
            startTime: this.startTime || null,//开始时间
            endTime: this.endTime || null,//结束时间
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 时间区间搜索
    gettime() {
      this.startTime = this.formInline.time ? this.formInline.time[0] || "" : "";
      this.endTime = this.formInline.time ? this.formInline.time[1] || "" : "";
      this.getRequestList()
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.order {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
</style>
